import React from 'react'

const Reporting = () => {
  return (
    <div>
      <h1>reporting</h1>
    </div>
  )
}

export default Reporting
